import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';

@Component({
    selector: 'app-bukku-services',
    standalone: true,
    imports: [CommonModule, TranslateModule, SlickCarouselModule],
    templateUrl: './bukku-services.component.html',
    styleUrl: './bukku-services.component.scss',
})
export class BukkuServicesComponent {
    servicesData = [
        {
            img: 'assets/images/icons/target.png',
            title: 'DIGITAL_SERVICES.BUKKU.BENEFITS.1.TITLE',
            desc: 'DIGITAL_SERVICES.BUKKU.BENEFITS.1.DESC'
        },
        {
            img: 'assets/images/icons/reach.png',
            title: 'DIGITAL_SERVICES.BUKKU.BENEFITS.2.TITLE',
            desc: 'DIGITAL_SERVICES.BUKKU.BENEFITS.2.DESC'
        },
        {
            img: 'assets/images/icons/smart.png',
            title: 'DIGITAL_SERVICES.BUKKU.BENEFITS.3.TITLE',
            desc: 'DIGITAL_SERVICES.BUKKU.BENEFITS.3.DESC'
        },
        {
            img: 'assets/images/icons/engagement.png',
            title: 'DIGITAL_SERVICES.BUKKU.BENEFITS.4.TITLE',
            desc: 'DIGITAL_SERVICES.BUKKU.BENEFITS.4.DESC'
        },
    ];

    slideConfig = {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        centerMode: false,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    centerMode: false,
                    infinite: false,
                },
            },
        ],
    };
}
